import { createSelector } from '@reduxjs/toolkit';
import { Project } from '../models/projects';
import { User } from '../models/user';
import { AppState, projectSelector } from '../store/store';

export const selectProjects = createSelector([
    (state: AppState) => projectSelector.selectAll(state),
    (state: AppState) => state.device.user
], (projects: Project[], user?: User) => {
    const franchiseId = user?.franchiseId;
    return projects.filter(p => franchiseId == p.franchiseId);
});
